import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// @ts-ignore
import { makeSelectFinalFormUnsavedValues } from 'services/finalFormsUnsavedValues/selectors';

interface IOwnProps {
    namespace: string;
    batch: Function;
    change: Function;
}

interface IStateProps {
    unsavedValues?: {
        create: [
            {
                uuid: string;
                personId?: number;
            }
        ];
        update: [
            {
                uuid: string;
                personId?: number;
            }
        ];
        delete: string[];
    };
}

interface IDispatchProps {}

interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class FormApplyUnsavedValues extends React.Component<IProps> {
    componentDidMount() {
        const { unsavedValues, batch, change } = this.props;

        if (unsavedValues) {
            const createdValues = unsavedValues.create;
            const updatedValues = unsavedValues.update;
            const deletedValues = unsavedValues.delete;
            batch(() => {
                if (createdValues) {
                    createdValues.forEach(createdValue => {
                        // HACK filter by personId to remove ghost entries
                        if (createdValue.personId) {
                            change(createdValue.uuid, createdValue);
                        }
                    });
                }
                if (updatedValues) {
                    updatedValues.forEach(updatedValue => {
                        // HACK filter by personId to remove ghost entries
                        if (updatedValue.personId) {
                            change(updatedValue.uuid, updatedValue);
                        }
                    });
                }
                if (deletedValues) {
                    deletedValues.forEach(deletedValue => {
                        change(deletedValue, undefined);
                    });
                }
            });
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    unsavedValues: makeSelectFinalFormUnsavedValues()
});

export default connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps)(
    FormApplyUnsavedValues
);
